<div *ngIf="!loading" class="container margin-top-1 margin-bottom-2">
  <div class="row">
    <!-- Left -->
    <div class="col-12 col-md-6 margin-top-1">
      <!-- Photo -->
      <mat-card class="custom-dashboard-mat-card">
        <div class="row" [ngClass]="{ 'justify-content-center': user.profile_photo_path }">
          <div class="col-12 col-sm-4 col-md-12 col-lg-4 flex-center">
            <img id="dashboard-photo" [src]="user.profile_photo_path" appErrorImage class="dashboard-image-user" (click)="photo.click()" />
            <input #photo type="file" accept="image/png,image/jpeg" (change)="onSelectFile($event.target)" style="display: none" />
          </div>

          <div *ngIf="!user.profile_photo_path" class="mat-caption margin-top-1 col-12 col-sm-8 col-md-12 col-lg-8">
            {{ "teacher-image-advices-dialog-1" | translate }}
            <ul>
              <li>{{ "teacher-image-advices-dialog-2" | translate }}</li>
              <li>{{ "teacher-image-advices-dialog-3" | translate }}</li>
              <li>{{ "teacher-image-advices-dialog-4" | translate }}</li>
              <li>{{ "teacher-image-advices-dialog-5" | translate }}</li>
              <li>{{ "teacher-image-advices-dialog-6" | translate }}</li>
              <li>{{ "teacher-image-advices-dialog-7" | translate }}</li>
            </ul>
          </div>
        </div>
        <p class="pt-2 text-center"><strong>{{user.name}} {{user.surname}}</strong></p>
        <p class="small pt-2 text-secondary text-center"><i class="fas fa-info-circle"></i> {{ "click-change-image" | translate }}</p>
      </mat-card>

      <mat-card class="custom-dashboard-mat-card margin-top-1">
        <div class="mat-h3 font-weight-bold">
          <i class="fas fa-chart-bar"></i> {{ "rating-avg" | translate }}
        </div>
        <mat-star-rating [rating]="rating" [starCount]="5" [disabled]="true" color="primary">
        </mat-star-rating>
      </mat-card>

      <mat-card class="margin-top-1">
        <div class="mat-h3 font-weight-bold">
          <i class="fas fa-user-graduate"></i> 
          {{
          "current-active-students"
          | translate: "{students:" + activeStudents + "}"
          }}
        </div>
      </mat-card>

      <mat-card class="margin-top-1" *ngIf="hasSocialNetworks">
        <div class="flex-start blue social-networks-icons">
          <mat-icon svgIcon="twitter-brand" class="social-network-icons" *ngIf="socialNetworks.twitter"
            (click)="openSocialNetwork('twitter')"></mat-icon>
          <mat-icon svgIcon="facebook-brand" class="social-network-icons" *ngIf="socialNetworks.facebook"
            (click)="openSocialNetwork('facebook')"></mat-icon>
          <mat-icon svgIcon="instagram-brand" class="social-network-icons" *ngIf="socialNetworks.instagram"
            (click)="openSocialNetwork('instagram')"></mat-icon>
          <mat-icon svgIcon="linkedin-brand" class="social-network-icons" *ngIf="socialNetworks.linkedin"
            (click)="openSocialNetwork('linkedin')"></mat-icon>
        </div>
      </mat-card>

      <mat-expansion-panel class="custom-dashboard-mat-card margin-top-1 black">
        <mat-expansion-panel-header class="black margin-top-2">
          <div class="mat-h3 font-weight-bold">
            <i class="fas fa-share-alt"></i> {{ "social-media" | translate }}
            <p class="mat-caption black"> {{ "explanation-social-network" | translate }}*</p>
          </div>
        </mat-expansion-panel-header>

        <form (ngSubmit)="updateSocialMedia()" [formGroup]="socialMediaForm" class="black">
          <mat-form-field appearance="legacy">
            <mat-label>{{ "twitter" | translate }}</mat-label>
            <input matInput formControlName="twitter" name="twitter" autocomplete="twitter" />
          </mat-form-field>
          <mat-form-field appearance="legacy">
            <mat-label>{{ "facebook" | translate }}</mat-label>
            <input matInput formControlName="facebook" name="facebook" autocomplete="facebook" />
          </mat-form-field>
          <mat-form-field appearance="legacy">
            <mat-label>{{ "instagram" | translate }}</mat-label>
            <input matInput formControlName="instagram" name="instagram" autocomplete="instagram" />
          </mat-form-field>
          <mat-form-field appearance="legacy">
            <mat-label>{{ "linkedin" | translate }}</mat-label>
            <input matInput formControlName="linkedin" name="linkedin" autocomplete="linkedin" />
          </mat-form-field>

          <div class="d-flex justify-content-center">
            <button type="submit" mat-raised-button color="primary">
              {{ "update" | translate }}
            </button>
          </div>
        </form>
        <!-- </mat-card> -->
      </mat-expansion-panel>

      <mat-expansion-panel class="custom-dashboard-mat-card margin-top-1 black">
        <mat-expansion-panel-header class="black margin-top-2">
          <div class="mat-h3 font-weight-bold">
            <i class="fas fa-eye"></i> Visibilidad
            <p class="mat-caption black"> 
              <span class="">Estado:</span> 
              <span *ngIf="hide_perfil==0 && hide_admin_perfil==0" class="primary bold" > VISIBLE</span> 
              <span *ngIf="hide_perfil==1 || hide_admin_perfil==1" class="grey bold" > OCULTO</span> 
            </p>
          </div>
        </mat-expansion-panel-header>
        <div *ngIf="hide_admin_perfil==0" >
          <p class="black pt-4" >
          <span *ngIf="hide_perfil==0" class="small">Tu perfil se encuentra en las búsquedas y los alumnos puden reservar horas</span>
          <span *ngIf="hide_perfil==1" class="small">Tu perfil se encuentra oculto tus alumnos puden reservar horas ya compradas.</span>
          </p>
          <p class="black" >Desde aquí podrás ocultar o mostrar tu perfil públicamente. Si desactivas tu perfil no podrán encontrarte y reservar horas. Recuerda que las clases individuales y clases grupales programadas no se cancelarán y deberás impartirlas. Los alumnos que tengan horas compradas contigo podrán reservar sus horas normalmente.</p>
          <a class="btn btn-secondary" *ngIf="hide_perfil==0" (click)="hidePerfil('1')"><i class="fas fa-eye-slash"></i>  OCULTAR PERFIL</a>
          <a class="btn btn-primary" *ngIf="hide_perfil==1" (click)="hidePerfil('0')"><i class="far fa-eye"></i>  ACTIVAR PERFIL</a>
        </div>
        <div *ngIf="hide_admin_perfil==1">
          <p class="black">Tu perfil esta desactivado por los administradores de Wordiix, contacta con nosotros para resolver la incidencia y poder volver a activar de nuevo tu perfil.</p>
        </div>
 
      </mat-expansion-panel>
    </div>

    <!-- Right -->
    <div class="col-12 col-md-6 margin-top-1">
      <div class="d-flex flex-column content-buttons padding-left-2 padding-right-2">

<!-- 
        <div 
        *ngIf="user.isPremium==false" 
        class="margin-top-1">
        <p>
          Crea o gestiona tus clases grupales
        </p>
          <button mat-raised-button color="primary" (click)="general.onlyPremiumTeachers()">
            <i class="fas fa-users"></i> {{ "group-classes" | translate }}
          </button>
        </div> -->

        <div
          
            class="margin-top-1">
          <p>{{ "manage-groupal-class" | translate }} </p>
          <button mat-raised-button color="primary" [routerLink]="['/teacher/group-classes']">
            <i class="fas fa-users"></i> {{ "group-classes" | translate }}
          </button>
        </div>


      </div>

      <mat-card class="custom-dashboard-mat-card margin-top-1">
        <div class="mat-h3 font-weight-bold primary">
          <i class="fas fa-business-time"></i> {{ "your-next-class" | translate }}:
        </div>

        <div *ngIf="!nextClass; else hasClassTemplate">
          <div class="margin-vertical-1 margin-left-1 light-gray">
            {{ "not-next-class" | translate }}
          </div>
        </div>

        <ng-template #hasClassTemplate>
          <div class="pt-3">
            <div>
              <span class="bold primary">{{ "student" | translate }}:</span>
              {{ nextClass.student_name }}
            </div>
            <div>
              <span class="bold primary">{{ "subject" | translate }}:</span>
              {{ nextClass.lesson_name }}
            </div>
            <div>
              <span class="bold primary">{{ "start" | translate }}:</span>
              {{ nextClassStart }} h.
            </div>
            <div>
              <span class="bold primary">{{ "end" | translate }}:</span>
              {{ nextClassEnd }} h.
            </div>
          </div>
          <button *ngIf="nextClassButton" class="margin-top-1 width-100" mat-raised-button color="primary" [routerLink]="nextClass.is_group == 1 ? ['/class/group_class/' + nextClass.id] : ['/class/single_class/' + nextClass.id]">
            {{ "access-to-class" | translate }}
          </button>
        </ng-template>
      </mat-card>

      
      <mat-card class="custom-dashboard-mat-card margin-top-1">
        <div class="mat-h3 font-weight-bold pb-3">
          <i class="fas fa-business-time"></i> {{ "video-presentation" | translate }}:
        </div>

        <span *ngIf="video_presentation ">
          <div *ngIf="video_presentation != null" style="padding:56.25% 0 0 0;position:relative;">
            <iframe [src]="video_presentation | domSeguro" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="videoLena"></iframe>
          </div>
          <script src="https://player.vimeo.com/api/player.js"></script>
        </span>
        <div *ngIf="video_presentation == null" [innerHTML]="'no-video-teacher' | translate"></div>
      </mat-card>
    
      <mat-card 
          *ngIf="user.isPremium==true"
          class="custom-dashboard-mat-card margin-top-1" >
        <div class="mat-h3">
          {{ "premium-referral-text" | translate }}
        </div>

        <div class="margin-top-1">
          <button mat-raised-button color="primary" (click)="generatePremiumLink()">
            <i class="fas fa-link"></i> {{ "generate-link" | translate }}
          </button>
        </div>
      </mat-card>

      <mat-card 
      *ngIf="user.isPremium==false"
      class="custom-dashboard-mat-card margin-top-1" >
          <div class="">
            {{ "invite-student-message" | translate }} 
          </div>

          <div class="margin-top-1">
            <button mat-raised-button color="primary" (click)="general.onlyPremiumTeachers()">
              <i class="fas fa-link"></i> {{ "generate-link" | translate }}
            </button>
          </div>
      </mat-card>


    </div>
  </div>
</div>